import { useContext, useEffect} from "react"
import FloatingContext from "../contexts/FloatingContext"
import useModal from "../hooks/useModal"
import GlobalContext from "../contexts/GlobalContext"
import Section from "../components/Section"
import SectionHeader from "../components/SectionHeader"
import SectionContent from "../components/SectionContent"
import List from "../components/List"

export default function Liquidations(){

    const [floatingContext, setFloatingContext] = useContext(FloatingContext)
    const {changeModal}=useModal()
    const [globalContext]=useContext(GlobalContext)
    const canSeeConciliations = !!(globalContext && globalContext.profile && globalContext.profile.permissions_granted && globalContext.profile.permissions_granted.find(({alias})=>alias==="master_admin"))

    useEffect(()=>{
        // Set default filter value in FloatingContext so the filter panel shows it pre-selected
        if(!floatingContext.value || Object.keys(floatingContext.value).length === 0){
            setFloatingContext(prev => ({
                ...prev,
                value: {
                    period: "last_15_days",
                    month: "",
                    year: "",
                    date: "",
                    date_start: "",
                    date_end: "",
                    company: [],
                    card: [],
                    bank: [],
                    operations: "",
                    payment: []
                }
            }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return(
        <Section>
            <SectionHeader
                title="Liquidaciones"
                intro="Acreditaciones de pagos en cuentas bancarias."
                back=""
                button={null}
                tabs={[
                    {label:"Transacciones",to:"/c24/actividad"},
                    {label:"Liquidaciones",labelShort:"Liquida...",to:"/c24/actividad/liquidaciones"},
                    ...(canSeeConciliations ? [{label:"Conciliaciones",labelShort:"Concilia...",to:"/c24/actividad/conciliaciones"}] : []),
                    {label:"Cuenta comercial",labelShort:"Cuenta",to:"/c24/actividad/cuenta"}
                ]}
            />
            <SectionContent>
                <List config={{
                    section:"liquidations",
                    endpoint:"liquidations/list",
                    limit:100,
                    counter:{
                        singular:"liquidación",
                        plural:"liquidaciones"
                    },
                    action:{
                        mode:"modal",
                        context:"liquidation",
                        reference:"liquidation-info"
                    },
                    defaultFilters: {
                        period: "last_15_days",
                        month: "",
                        year: "",
                        date: "",
                        date_start: "",
                        date_end: "",
                        company: [],
                        card: [],
                        bank: [],
                        operations: "",
                        payment: []
                    },
                    createLiquidation: (globalContext && globalContext.profile && globalContext.profile.permissions_granted && globalContext.profile.permissions_granted.find(({alias})=>alias==="master_admin"))
                        ? ()=>{ changeModal("create-liquidation", "", 0) }
                        : null
                }} />
            </SectionContent>
        </Section>
    )
    
}